export default __webpack_public_path__ + "static/h13-79ad7f3db84d9c94d4e5503450adfba8.png";